import { MerchantBusinessHour } from '../../interfaces/merchants';

export type TemporaryBusinessHoursTextArray = {
  date: string;
  hours: Array<String>;
};

export type TemporaryClosingDaysTextArray = {
  startDate: string;
  endDate: string;
  reason: string;
};

// TODO: Refactoring
class DateTimeUtils {
  public static formatWeekday(dayNumber: number): string {
    switch (dayNumber) {
      case 0:
        return '日';
      case 1:
        return '月';
      case 2:
        return '火';
      case 3:
        return '水';
      case 4:
        return '木';
      case 5:
        return '金';
      case 6:
        return '土';
      default:
        return '';
    }
  }

  public static formatBusinessHours(
    businessHours: MerchantBusinessHour[],
  ): string[] {
    const result: string[] = [];
    const weekdays = DateTimeUtils.getWeekdays(businessHours);
    const monday = weekdays[0];
    if (DateTimeUtils.isWeekdayEverySameTime(weekdays, monday)) {
      // eslint-disable-next-line no-irregular-whitespace
      result.push(
        DateTimeUtils.formatBizHourString(
          '月〜金',
          monday.opening_hour,
          monday.closing_hour,
        ),
      );
    } else {
      weekdays.forEach((d: MerchantBusinessHour) => {
        if (d.is_open) {
          result.push(DateTimeUtils.formatOpenBusinessHour(d));
        } else {
          result.push(DateTimeUtils.formatCloseBusinessHour(d));
        }
      });
    }

    const weekend = DateTimeUtils.getWeekend(businessHours);
    const sunday = weekend[0];
    if (DateTimeUtils.isWeekendEverySameTime(weekend, sunday)) {
      // eslint-disable-next-line no-irregular-whitespace
      result.push(
        DateTimeUtils.formatBizHourString(
          '土・日',
          sunday.opening_hour,
          sunday.closing_hour,
        ),
      );
    } else {
      weekend.reverse().forEach((d: MerchantBusinessHour) => {
        if (d.is_open) {
          result.push(DateTimeUtils.formatOpenBusinessHour(d));
        } else {
          result.push(DateTimeUtils.formatCloseBusinessHour(d));
        }
      });
    }

    return result;
  }

  public static getWeekdays(businessHours: MerchantBusinessHour[]) {
    return businessHours.filter((v) => v.weekday > 0 && v.weekday < 6);
  }

  public static getWeekend(businessHours: MerchantBusinessHour[]) {
    return businessHours.filter((v) => v.weekday === 0 || v.weekday === 6);
  }

  public static isWeekdayEverySameTime(
    weekdays: MerchantBusinessHour[],
    monday: MerchantBusinessHour,
  ) {
    return weekdays.every(
      (d: MerchantBusinessHour) =>
        d.is_open &&
        monday.opening_hour === d.opening_hour &&
        monday.closing_hour === d.closing_hour,
    );
  }

  public static isWeekendEverySameTime(
    weekdays: MerchantBusinessHour[],
    sunday: MerchantBusinessHour,
  ) {
    return weekdays.every(
      (d: MerchantBusinessHour) =>
        d.is_open &&
        sunday.opening_hour === d.opening_hour &&
        sunday.closing_hour === d.closing_hour,
    );
  }

  public static formatOpenBusinessHour(date: MerchantBusinessHour): string {
    const weekday = DateTimeUtils.formatWeekday(date.weekday);
    const open = date.opening_hour;
    const close = date.closing_hour;
    // eslint-disable-next-line no-irregular-whitespace
    return DateTimeUtils.formatBizHourString(weekday, open, close);
  }

  public static formatCloseBusinessHour(date: MerchantBusinessHour): string {
    const weekday = DateTimeUtils.formatWeekday(date.weekday);
    // eslint-disable-next-line no-irregular-whitespace
    return `${weekday}　定休日\n`;
  }

  private static formatBizHourString(
    week: string,
    open: string,
    close: string,
  ): string {
    return `${week}　${open.substring(0, 5)} - ${close.substring(0, 5)}\n`;
  }
}

export default DateTimeUtils;
